import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeRepairRequestCommand } from './serialize';

/**
 * 刪除報修單草稿（實體刪除）。
 * POST `/aftersales/repair-request/{id}/delete`（**非** HTTP DELETE）。
 * 僅 DRAFT；body 僅 `{ updatedAt }`。成功 `data: null`。
 *
 * @param {string} id
 * @param {{ updatedAt?: string, record?: { updatedAt?: string } }} [payload]
 */
export async function deleteDraftRepairRequest(id, payload = {}) {
  const { data: raw } = await request.post(
    `/aftersales/repair-request/${id}/delete`,
    serializeRepairRequestCommand(payload),
  );
  return parseVer4DetailResponse(raw);
}
